<template>
  <VTDropdownPill
    :disable-save-button="formHasError()"
    :is-enabled="!disabled"
    @confirm="onConfirmClick"
    @clear="onClearClick"
    @on-click-outside="resetState"
  >
    <template #dropDownHeader>
      <VTPill label="Cooldown">
        <template #values>
          <div :class="$style.displayer">
            <span>
              <strong>{{ props.modelValue.days }}</strong>
              Days
            </span>
            <span>
              <strong>{{ props.modelValue.hours }}</strong>
              Hours
            </span>
          </div>
        </template>
      </VTPill>
    </template>
    <template #dropdown-content>
      <div :class="$style.dropdownContentWrapper">
        <span>Cooldown after purchase</span>
        <div :class="$style.dropdownInputsWrapper">
          <div :class="$style.dropdownInput">
            <span>Days</span>
            <InputNumber v-model="formValues.days" :min="0" :max="1000" :input-class="$style.input" />
          </div>
          <div :class="$style.dropdownInput">
            <span>Hours</span>
            <InputNumber v-model="formValues.hours" :min="0" :max="23" :input-class="$style.input" />
          </div>
        </div>
        <span v-if="formHasError()" :class="$style.errorMessage">Days and hours must not be empty</span>
        <span :class="$style.dropdownBottonText">
          Time after purchase in which the offer won’t be available to the player
        </span>
      </div>
    </template>
  </VTDropdownPill>
</template>

<script setup lang="ts">
import VTDropdownPill from "@/components/VTDropdownPill";
import VTPill from "@/components/VTPill";
import InputNumber from "primevue/inputnumber";
import type { PropType } from "vue";
import { ref } from "vue";

interface CoolDownInput {
  days: number;
  hours: number;
}

const props = defineProps({
  modelValue: {
    type: Object as PropType<CoolDownInput>,
    required: true,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(["update"]);

const formValues = ref({
  ...props.modelValue,
});

const formHasError = () => formValues.value.days === null || !formValues.value.hours === null;

const onConfirmClick = () => {
  emit("update", formValues.value);
};

const onClearClick = () => {
  formValues.value = {
    days: 0,
    hours: 0,
  };

  emit("update", formValues.value);
};

const resetState = () => {
  formValues.value = props.modelValue;
};
</script>
<style module>
.displayer {
  display: flex;
  gap: 8px;
}

.dropdownContentWrapper {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding-bottom: 8px;
}

.dropdownInputsWrapper {
  display: flex;
  gap: 16px;
}

.dropdownInput {
  display: flex;
  gap: 8px;
  width: 112px;
  align-items: center;
}

.input {
  width: 100%;
}

.dropdownBottonText {
  color: #909298;
  font-size: 12px;
}

.errorMessage {
  color: #ff4d4f;
  font-size: 12px;
}
</style>
